import React, { FC } from "react";

const circleCheck: FC = () => {
    return (
        <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5Z"
                fill="#0679E3"
            />
            <path
                d="M18.4951 8.25236C18.7997 8.53795 18.7997 9.02151 18.4951 9.3071L10.0643 17.2109L6.50511 13.8742C6.20037 13.5885 6.20037 13.1048 6.50511 12.8191C6.78303 12.5585 7.21541 12.5583 7.49364 12.8185L10.0643 15.2226L17.5065 8.25212C17.7846 7.99166 18.2171 7.99176 18.4951 8.25236Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(circleCheck);
